// extracted by mini-css-extract-plugin
module.exports = {"tabs":"SpvAdmin_tabs__cI_CO"};